// @flow
import moment from 'moment-timezone';
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import map from 'ramda/es/map';
import sort from 'ramda/es/sort';
import ascend from 'ramda/es/ascend';
import prop from 'ramda/es/prop';
import toPairs from 'ramda/es/toPairs';
import reduce from 'ramda/es/reduce';
import when from 'ramda/es/when';
import identity from 'ramda/es/identity';
import filter from 'ramda/es/filter';

import type { Params, ScheduleWeek, Subject } from 'app/dataTypes/ScheduleWeek.types';
import type { Mark } from 'app/dataTypes/Mark.types';

import type { Request } from '../../index';


const dateFormatApi: 'YYYY-MM-DD' = 'YYYY-MM-DD';

type ParamsApi = {
  klass_id: number,
  student_id: number,
  date: string,
}

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { studentId, klassId, date } = params;

  return [{
    student_id: parseInt(studentId, 10),
    klass_id: parseInt(klassId, 10),
    date: date.getString(dateFormatApi),
  }, null];
};

type DateApi = {
  [lesson_num: string]: {
    schedule_id: number,
    videomeet_link: string | null,
    discipline: string,
    starts_at: string,
    ends_at: string,
    homework: string,
    homework_assignment_schedule_ids: Array<number>,
    homework_solution_schedule_id: number,
    subject: string,
    assignments: Array<number>, // deprecated
    room: string,
    marks: Array<{
      value: string,
      description: string,
    }>
  },
}

type ResultApi = {
  [date: string]: DateApi,
  result: 'success',
}

const weekTemplate = [null, null, null, null, null, null];

const convertMarks = (marksMaybe: Array<Object>): Array<Mark> => {
  if (marksMaybe && marksMaybe instanceof Array) {
    return pipe(
      map(({ value, description }) => (value || value === 0 ? {
        value: String(value),
        description: description || null,
      } : null)),
      filter(identity),
    )(marksMaybe);
  }
  return [];
};

export const convertResult = (res: ResultApi): ScheduleWeek => {
  const { result, ...datesMap } = res;
  return pipe(
    toPairs,

    reduce((acc, [date, val]) => {
      const mDate = moment(date, dateFormatApi);
      if (mDate.isValid()) {
        const wday = mDate.day();
        if (wday > 0 && wday < 7) {
          acc[mDate.day() - 1] = { ...val };
        }
      }
      return acc;
    }, [...weekTemplate]),

    map(when(identity, pipe(
      values,
      map(({
        schedule_id: id,
        discipline,
        videomeet_link: videomeetLink,
        starts_at: startAt,
        ends_at: endAt,
        marks,
        room,
        subject,
        homework,
        homework_solution_schedule_id: homeworkSolutionScheduleId,
        homework_assignment_schedule_ids: homeworkAssignmentScheduleIds,
        // assignments: // deprecated
      }): Subject => ({
        id: String(id),
        title: discipline || '',
        videomeetLink,
        startAt,
        endAt,
        marks: convertMarks(marks),
        room: room || '',
        theme: subject || '',
        homeworkTask: homework || '',
        homeworkSolutionScheduleId: String(homeworkSolutionScheduleId),
        homeworkAssignmentScheduleIds: homeworkAssignmentScheduleIds || [],
      })),
      sort(ascend(prop('startAt'))),
    ))),
  )(datesMap);
};

export const GET_WEEK: Request<
  Params,
  ScheduleWeek,
  void
> = [
  'cabinet/dnevnik/week',
  'get',
  ['data'],
];
